export const BlockReasonEnum = [
  { text: 'Lost', value: 'LOST' },
  { text: 'Counterfeit', value: 'COUNTERFEIT' },
  { text: 'Abuse', value: 'ABUSE' },
  { text: 'Stolen', value: 'STOLEN' },
  { text: 'Not Delivered', value: 'NOT_DELIVERED' },
  { text: 'Refund', value: 'REFUND' },
  { text: 'Other', value: 'OTHER' }
]
